/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { SnippetCreateBodyDoc } from './snippetCreateBodyDoc';
import type { SnippetCreateVisibility } from './snippetCreateVisibility';

export interface SnippetCreate {
  /**
     * @minLength 1
     * @maxLength 200
     */
  name: string;
  body_doc: SnippetCreateBodyDoc;
  visibility?: SnippetCreateVisibility;
}
